import { render, staticRenderFns } from "./niandai.vue?vue&type=template&id=8fdc3f3a&scoped=true&"
import script from "./niandai.vue?vue&type=script&lang=js&"
export * from "./niandai.vue?vue&type=script&lang=js&"
import style0 from "./niandai.vue?vue&type=style&index=0&id=8fdc3f3a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8fdc3f3a",
  null
  
)

export default component.exports